import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.integranube.cl',
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  const tenantid = localStorage.getItem('tenantid');

  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (tenantid) config.headers.TenantId = tenantid;

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      window.dispatchEvent(new Event('integranube:session-expired'));
    }
    return Promise.reject(error);
  }
);

export default api;
